const config: AppConfig = {
  apiUrl: '/teiji',
  ...(typeof window !== 'undefined' ? window.APP_CONFIG : {}),
};

export default config;
